module.exports = __webpack_public_path__ + "assets/img/1f998afce8f886b552de7dc39c331d30.svg";